module.exports = __webpack_public_path__ + "img/5@2x.c96f685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/5@2x.png
// module id = 9VoH
// module chunks = 0